"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCianHost = useCianHost;
var _subdomain = require("../selectors/subdomain");
/*
 * TODO удалить параметр useSelector, когда обновится react-redux@6 до react-redux@7 во frontend-mobile-website - https://jira.cian.tech/browse/AUD-1778
 * В react-redux@6 ещё не было useSelector и useDispatch, поэтому мы прокидываем их ручками.
 * После того как обновим старый мобсайт нужно использовать useSelector и useDispatch из react-redux,
 * а эти пропсы удалить вовсе. Прослойку connect больше ни для каких целей не используем, это временное решение.
 */

function useCianHost(_ref) {
  let {
    useSelector
  } = _ref;
  const subdomain = useSelector(_subdomain.subdomainSelector);
  return `https://${subdomain}.cian.ru`;
}